import React from "react";

export default function Web_HTML() {
  return (
    <div>
      <h1>What is HTML</h1>
      <p>
        Route: <code>/web/html</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
